import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {AuthenticationService} from '@services/authentification.service';
import {Router} from '@angular/router';
import {environment} from '~/environments/environment';
import {AlertService} from '@services/alert.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(
        private router: Router,
        public authenticationService: AuthenticationService,
        private alertService: AlertService) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            if (err.status === 401) {
                if (this.authenticationService.currentUserToken !== '' && this.authenticationService.currentUserToken !== null) {
                    // auto logout if 401 response returned from api
                    this.authenticationService.logout();
                    location.reload();
                }
            } else if (err.status === 403 && err.error.message == "token_outdate") {
                this.authenticationService.logout();
                window.location.replace('/app/login?error=token');
                this.alertService.error('Un autre utilisateur s\'est connecté sur votre compte LyBox, vous avez été automatiquement déconnecté. Si vous n\'êtes pas à l\'origine de cette manoeuvre, nous vous conseillons de changer immédiatement votre mot de passe. En cas de problème, vous pouvez nous contacter à contact@lybox.fr', true);
                return throwError('token_outdate');
            } else if (err.status === 404) {
                if (request.url !== `${environment.apiUrl}app/forgotPassword` && request.url !== `${environment.apiUrl}app/login`) {
                    this.router.navigate(['404']);
                }
            } else if (err.status == 0) {
                document.getElementById("mainLoader").classList.remove("d-none");
                setTimeout(function() {
                    location.reload();
                }, 10000);
            }

            let error = '';
            console.log(err);
            if (err.error && err.error.errors) {
                err.error.errors.forEach((txt) => {
                    error += txt.message;
                });
            } else if (err.error && err.error.message) {
                error = err.error.message;
            } else {
                error = err.statusText;
            }
            console.log(error);
            return throwError(error);
        }));
    }
}
